import React from 'react';
import { LoanApprovalDataProvider } from './LoanApprovalDataProvider';
import LoanDetailsView from './LoanDetailsView';

interface LoanDetailsViewWithProviderProps {
  data?: any;
  formikProps?: any;
  onSubmit?: (values: any) => void;
}

const LoanDetailsViewWithProvider: React.FC<LoanDetailsViewWithProviderProps> = (props) => {
  return (
    <LoanApprovalDataProvider
      valueData={props.formikProps?.values?.valueData || props.data?.valueData}
      data={props.data}
      formikProps={props.formikProps}
    >
      <LoanDetailsView {...props} />
    </LoanApprovalDataProvider>
  );
};

export default LoanDetailsViewWithProvider;
